import _ from 'lodash';

import { ILevelDomainData, levelDomainData } from 'src/app/infrastructure/models/level-domain-data';
import { IContactTypeForm } from './contact-type-form';
import { IContactTypeDto, contactTypeDto } from 'src/assets/common/models/contact-type-dto.g';

export interface IContactTypeCache {
    data: IContactTypeData;
    url: string;
}

export const contactTypeData = {
    ...levelDomainData,
    guid: 'guid',
    nr: 'nr',
    description: 'description',
    system: 'system',
    deleted: 'deleted',    
    inactive: 'inactive',
} as const;

export type TContactTypeData = (typeof contactTypeData)[keyof typeof contactTypeData];

export interface IContactTypeData extends ILevelDomainData {
    [contactTypeData.guid]: string;
    [contactTypeData.nr]: number | null;
    [contactTypeData.description]: string | null;
    [contactTypeData.system]: boolean | null;
    [contactTypeData.deleted]: boolean;
    [contactTypeData.inactive]: boolean;
}

export class ContactTypeData
    implements IContactTypeData, ILevelDomainData
{
    [contactTypeData.guid]!: string;
    [contactTypeData.nr]: number | null = null;
    [contactTypeData.description]: string | null = null;
    [contactTypeData.system]: boolean | null = null;
    [contactTypeData.deleted]!: boolean;
    [contactTypeData.inactive]!: boolean;

    protected constructor(modelDto?: IContactTypeDto | null);
    protected constructor(modelData: IContactTypeData, modelForm: IContactTypeForm);
    protected constructor(value?: IContactTypeDto | IContactTypeData | null, modelForm?: IContactTypeForm) {
        if (!!modelForm) {
            const _modelData = value as IContactTypeData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IContactTypeDto;
            this[contactTypeData.guid] = _modelDto?.[contactTypeDto.guid]!;
            this[contactTypeData.nr] = _modelDto?.[contactTypeDto.nr];
            this[contactTypeData.description] = _modelDto?.[contactTypeDto.description];
            this[contactTypeData.system] = _modelDto?.[contactTypeDto.system];
            this[contactTypeData.deleted] = _modelDto?.[contactTypeDto.deleted]!;
            this[contactTypeData.inactive] = _modelDto?.[contactTypeDto.inactive]!;
        }
    }
        
    static create(modelDto?: IContactTypeDto | null): IContactTypeData | null
    static create(modelData: IContactTypeData, modelForm: IContactTypeForm): IContactTypeData | null
    static create(value?: IContactTypeDto | IContactTypeData | null, modelForm?: IContactTypeForm): IContactTypeData | null {

        if (!!modelForm) {
            const _modelData = value as IContactTypeData;
            return new ContactTypeData(_modelData, modelForm);
        } else {
            const _modelDto = value as IContactTypeDto;
            return _modelDto ? new ContactTypeData(_modelDto) : null;
        }
    }
}
